module.exports = require('./helpers/bundle-url').getBundleURL('7VwIV') + "opsgenie-left.49c0f64b.svg";